/**
 * Letter article — color scrub reveal and image animation.
 *
 * @package HelloElementorChild
 */

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { prefersReducedMotion } from './camst-counter.js';

gsap.registerPlugin(ScrollTrigger);

var letterInstances = new WeakMap();

export function initCamstLetterArticle(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-letter-article]'));
  } else if (scope.matches && scope.matches('[data-camst-letter-article]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-letter-article]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstLetterArticleInit === '1') {
      return;
    }

    root.dataset.camstLetterArticleInit = '1';

    if (prefersReducedMotion()) {
      Array.prototype.forEach.call(root.querySelectorAll('.camst-letter-reveal'), function (el) {
        el.style.color = '#141414';
      });

      Array.prototype.forEach.call(root.querySelectorAll('.camst-letter-article__figure-image'), function (image) {
        gsap.set(image, { scale: 1 });
      });

      return;
    }

    var ctx = gsap.context(function () {
      Array.prototype.forEach.call(root.querySelectorAll('.camst-letter-reveal'), function (el) {
        gsap.fromTo(
          el,
          { color: 'rgba(230, 66, 66, 0.2)' },
          {
            color: '#141414',
            ease: 'none',
            scrollTrigger: {
              trigger: el,
              start: 'top 80%',
              end: 'top 40%',
              scrub: true,
            },
          }
        );
      });

      Array.prototype.forEach.call(root.querySelectorAll('[data-camst-letter-image]'), function (figure) {
        var image = figure.querySelector('.camst-letter-article__figure-image');

        if (!image) {
          return;
        }

        gsap.set(image, { scale: 1.1, transformOrigin: 'center center' });

        gsap.to(image, {
          scale: 1,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: figure,
            start: 'top 92%',
            end: 'top 35%',
            scrub: 1.5,
          },
        });
      });
    }, root);

    letterInstances.set(root, ctx);
  });
}

export function teardownCamstLetterArticle(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-letter-article]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-letter-article]'));

  roots.forEach(function (root) {
    var ctx = letterInstances.get(root);

    if (ctx) {
      ctx.revert();
      letterInstances.delete(root);
    }

    delete root.dataset.camstLetterArticleInit;
  });
}

export function refreshCamstLetterArticle() {
  ScrollTrigger.refresh();
}
